module.exports = __webpack_public_path__ + "static/salehome-ccb749793acd8aed2879ab1ad80e4d22.jpeg";